import UniversalButton from "components/uiComponents/UniversalButton";
import { useDispatch, useSelector } from "react-redux";
import { addColorItemAC, deleteColorItemAC } from "store/actions/colorSidebar";
import { ReactComponent as PlusCircleIcon } from "../../../../static/icons/plus-circle.svg";
import ColorSettingsItem from "../ColorSettingsItem/ColorSettingsItem";
import "./SidebarTabsContent.scss";

const ConditionColorContent = (
  {
    columnType,
    colorSettingsItems,
  }
) => {

  const dispatch = useDispatch()
  
  const deleteSettingHandler = (id) => {
    dispatch(deleteColorItemAC(id))
  }

  const addNewSettingHandler = () => {
    dispatch(addColorItemAC(columnType))
  };

  const conditionCount = colorSettingsItems?.length ?? 0

  return (
    <div className="color-content">
      <span className="color-content-title">Condition ({conditionCount})</span>
      <div className="items-wrapper">
        {
          colorSettingsItems ? colorSettingsItems.map((colorSettingItem, index) => {

            const isTopDropDownElement = index >= colorSettingsItems.length - 2 && colorSettingsItems.length > 3
            const isFirstElement = index === 0
            
            const currentDropdownPosition = (isTopDropDownElement && !isFirstElement) ? "top" : "bottom"

             return <ColorSettingsItem
                        id={colorSettingItem.id}
                        currentColor={colorSettingItem.color}
                        currentOption={colorSettingItem.selectedOption}
                        inputsDataArray={colorSettingItem.inputsDataArray}
                        deleteItemCallback={deleteSettingHandler}
                        key={colorSettingItem.id}
                        dropdownVerticalPosition={currentDropdownPosition}
                        type={colorSettingItem.type}
                        options={colorSettingItem.options}
                    />
          })
          : null
        }
      </div>
      <UniversalButton
        leftIcon={<PlusCircleIcon />}
        labelColor="blue"
        onClick={addNewSettingHandler}
        backgroundHoverColor="blue-light"
        backgroundColor="blue"
        isFullWidth
        label="Add condition"
      />
    </div>
  );
};

export default ConditionColorContent;
